import React, { useRef, useState, useEffect } from 'react';
import domtoimage from 'dom-to-image-more';
import { Download, Printer, X, User } from 'lucide-react';
import { Button } from '../components/ui/button';

const API = process.env.REACT_APP_BACKEND_URL;

const PosterContent = ({ data, b64, loading }) => {
  const pUrl = (p) => p ? (p.startsWith('http') ? p : `${API}/api/files/${p}`) : null;
  const fmtDate = (d) => { if (!d) return ''; try { return new Date(d).toLocaleDateString('hi-IN', { day: 'numeric', month: 'long', year: 'numeric' }); } catch { return d; } };

  return (
    <>
      <div style={{ background: '#1a1a1a', color: '#fff', padding: '18px 20px', textAlign: 'center', position: 'relative' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '4px', background: 'linear-gradient(90deg, #b8860b, #daa520, #b8860b)' }} />
        <div style={{ fontSize: '14px', color: '#daa520', whiteSpace: 'nowrap' }}>ॐ शांति</div>
        <div style={{ fontSize: '32px', fontWeight: '900', lineHeight: 1, whiteSpace: 'nowrap' }}>श्रद्धांजलि</div>
        <div style={{ fontSize: '10px', color: '#999', letterSpacing: '3px', marginTop: '4px', whiteSpace: 'nowrap' }}>SHRADDHANJALI</div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', padding: '18px 0 8px', background: '#fafafa' }}>
        <div style={{ width: '180px', height: '220px', border: '4px solid #daa520', borderRadius: '6px', overflow: 'hidden', background: '#eee', boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }}>
          {loading ? <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '10px', color: '#999' }}>...</div>
          : (b64 || data.photo_url) ? <img src={b64 || pUrl(data.photo_url)} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
          : <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><User style={{ width: '40px', height: '40px', color: '#ccc' }} /></div>}
        </div>
      </div>

      <div style={{ textAlign: 'center', padding: '10px 24px 4px' }}>
        <div style={{ fontSize: '24px', fontWeight: '900', color: '#1a1a1a', lineHeight: 1.15, whiteSpace: 'nowrap' }}>{data.name}</div>
        <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', marginTop: '6px' }}>
          {data.age && <span style={{ fontSize: '13px', color: '#666', fontWeight: '600', whiteSpace: 'nowrap' }}>{data.age}</span>}
          {data.family_name && <span style={{ fontSize: '13px', color: '#b8860b', fontWeight: '700', whiteSpace: 'nowrap' }}>{data.family_name}</span>}
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', gap: '30px', padding: '8px', margin: '6px 50px', background: '#f5f0e8', borderRadius: '6px', border: '1px solid #e8dcc8' }}>
        {data.date_of_birth && <div style={{ textAlign: 'center' }}><div style={{ fontSize: '10px', color: '#999', fontWeight: '700' }}>जन्म</div><div style={{ fontSize: '13px', color: '#333', fontWeight: '700', marginTop: '2px' }}>{fmtDate(data.date_of_birth)}</div></div>}
        <div style={{ textAlign: 'center' }}><div style={{ fontSize: '10px', color: '#999', fontWeight: '700' }}>निधन</div><div style={{ fontSize: '13px', color: '#333', fontWeight: '700', marginTop: '2px' }}>{fmtDate(data.date_of_death)}</div></div>
      </div>

      <div style={{ textAlign: 'center', padding: '4px 20px', fontSize: '13px', color: '#555' }}>{data.village ? `${data.village}, ` : ''}{data.city}, {data.state}</div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '6px 60px' }}>
        <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, transparent, #daa520, transparent)' }} />
        <span style={{ color: '#daa520', fontSize: '14px' }}>✦</span>
        <div style={{ flex: 1, height: '1px', background: 'linear-gradient(90deg, transparent, #daa520, transparent)' }} />
      </div>

      <div style={{ padding: '4px 30px 16px', textAlign: 'center' }}>
        <p style={{ fontSize: '13px', color: '#444', lineHeight: 1.7, fontStyle: 'italic', whiteSpace: 'pre-line' }}>"{data.message}"</p>
      </div>

      <div style={{ background: '#1a1a1a', color: '#fff', padding: '12px 18px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div><div style={{ fontSize: '11px', color: '#daa520', marginBottom: '2px' }}>शोक संदेश</div><div style={{ fontSize: '15px', fontWeight: '700' }}>गुमसुदा पोर्टल</div><div style={{ fontSize: '10px', color: '#888', marginTop: '1px' }}>gumsuda.com | {data.sandesh_id}</div></div>
        <div style={{ textAlign: 'right' }}><div style={{ fontSize: '24px', color: '#daa520' }}>ॐ</div></div>
      </div>
    </>
  );
};

const ShokhPoster = ({ data, onClose }) => {
  const captureRef = useRef(null);
  const [b64, setB64] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dling, setDling] = useState(false);

  const pUrl = (p) => p ? (p.startsWith('http') ? p : `${API}/api/files/${p}`) : null;

  useEffect(() => {
    (async () => {
      const url = pUrl(data.photo_url);
      if (!url) { setLoading(false); return; }
      try {
        const r = await fetch(url); const bl = await r.blob();
        const rd = new FileReader(); rd.onloadend = () => { setB64(rd.result); setLoading(false); }; rd.readAsDataURL(bl);
      } catch { setLoading(false); }
    })();
  }, [data.photo_url]);

  const doCapture = async () => {
    const el = captureRef.current;
    if (!el) return null;
    await new Promise(r => setTimeout(r, 500));
    const nativeUrl = await domtoimage.toPng(el, {
      quality: 1,
      bgcolor: '#ffffff',
      cacheBust: true,
      width: el.offsetWidth,
      height: el.offsetHeight,
    });
    const img = new Image();
    img.src = nativeUrl;
    await new Promise((res, rej) => { img.onload = res; img.onerror = rej; });
    const canvas = document.createElement('canvas');
    canvas.width = img.width * 2;
    canvas.height = img.height * 2;
    const ctx = canvas.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/png');
  };

  const downloadPNG = async () => {
    if (dling) return;
    setDling(true);
    try {
      const dataUrl = await doCapture();
      if (!dataUrl) return;
      const link = document.createElement('a');
      link.download = `श्रद्धांजलि-${data.name || 'poster'}.png`;
      link.href = dataUrl;
      link.click();
    } catch (e) { console.error(e); }
    finally { setDling(false); }
  };

  const doPrint = async () => {
    try {
      const dataUrl = await doCapture();
      if (!dataUrl) return;
      const pw = window.open('', '_blank');
      pw.document.write(`<!DOCTYPE html><html><head><title>${data.name}</title>
<style>*{margin:0;padding:0;-webkit-print-color-adjust:exact!important;print-color-adjust:exact!important}
@page{size:A4 portrait;margin:0}body{margin:0}img{width:100%;height:auto;display:block}</style>
</head><body><img src="${dataUrl}" />
<script>window.onload=function(){setTimeout(function(){window.print();window.onafterprint=function(){window.close()}},500)}<\/script>
</body></html>`);
      pw.document.close();
    } catch (e) { console.error(e); }
  };

  const sc = Math.min(window.innerWidth < 500 ? (window.innerWidth - 40) / 595 : 420 / 595, 1);
  const props = { data, b64, loading };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-start justify-center overflow-y-auto" onClick={onClose} data-testid="shokh-poster-modal">
      <div className="w-full max-w-lg mx-auto my-4 bg-white rounded-2xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="sticky top-0 z-10 bg-white border-b px-4 py-3 flex items-center justify-between">
          <h3 className="font-outfit font-bold text-lg">श्रद्धांजलि पोस्टर</h3>
          <button onClick={onClose} className="p-2 hover:bg-gray-100 rounded-full"><X className="w-5 h-5" /></button>
        </div>
        <div className="px-4 py-3 flex gap-2 border-b">
          <Button onClick={downloadPNG} disabled={dling || loading} className="flex-1 bg-gray-900 hover:bg-gray-800 rounded-xl h-11 text-sm" data-testid="shokh-download-btn">
            <Download className="w-4 h-4 mr-2" />{dling ? 'डाउनलोड हो रहा...' : 'डाउनलोड PNG'}
          </Button>
          <Button onClick={doPrint} variant="outline" className="flex-1 rounded-xl h-11 text-sm" data-testid="shokh-print-btn">
            <Printer className="w-4 h-4 mr-2" />प्रिंट A4
          </Button>
        </div>

        {/* PREVIEW */}
        <div className="px-3 py-4 bg-gray-100 overflow-auto flex justify-center">
          <div style={{ width: `${595 * sc}px`, overflow: 'hidden' }}>
            <div style={{ width: '595px', background: '#fff', fontFamily: "'Outfit', sans-serif", border: '3px solid #1a1a1a', transform: `scale(${sc})`, transformOrigin: 'top left' }}>
              <PosterContent {...props} />
            </div>
          </div>
        </div>

        {/* HIDDEN CAPTURE (no transform, full size) */}
        <div style={{ position: 'fixed', left: '-9999px', top: 0 }}>
          <div ref={captureRef} style={{ width: '595px', background: '#fff', fontFamily: "'Outfit', sans-serif", border: '3px solid #1a1a1a' }}>
            <PosterContent {...props} />
          </div>
        </div>

        <div className="p-3 border-t">
          <div className="flex gap-2">
            <button onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(`श्रद्धांजलि: ${data.name}${data.age ? `, ${data.age}` : ''}\nनिधन: ${data.date_of_death}\n${data.city}, ${data.state}\n\n${data.message?.substring(0, 150)}\n\n${window.location.origin}/shokh-sandesh/${data.sandesh_id}`)}`, '_blank')} className="flex-1 py-2.5 bg-green-500 text-white text-sm font-medium rounded-xl text-center hover:bg-green-600">WhatsApp</button>
            <button onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(`${window.location.origin}/shokh-sandesh/${data.sandesh_id}`)}`, '_blank')} className="flex-1 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-xl text-center hover:bg-blue-700">Facebook</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShokhPoster;
